 document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.discount__copy');

    copyButtons.forEach(button => {
      button.addEventListener('click', function () {
        const codeSpan = this.previousElementSibling; // .discount__code
        const couponCode = codeSpan.textContent.trim();
        const originalText = this.textContent;

        // Copy to clipboard
        navigator.clipboard.writeText(couponCode)
          .then(() => {
            this.textContent = 'COPIED!';
            this.classList.add('copied'); // Optional: for styling

            setTimeout(() => {
              this.textContent = originalText;
              this.classList.remove('copied');
            }, 2000);
          })
          .catch(err => {
            console.error('Failed to copy coupon code: ', err);
          });
      });
    });
  });



document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('#pincode-input');
  const button = document.querySelector('.pincode-submit-button');
  const result = document.querySelector('.pincode-result');
  const icon = document.querySelector('.delivery-icon'); // grab the icon

  button.addEventListener('click', async () => {
    const pincode = input.value.trim();

    // Show icon as soon as user clicks check
    if (icon) icon.style.display = 'inline-block';

    // Validate pincode
    if (!/^\d{6}$/.test(pincode)) {
      result.textContent = 'Invalid pincode';
      result.style.color = 'red';
      return;
    }

    // Loading state
    result.textContent = 'Checking...';
    result.style.color = 'gray';
    button.disabled = true;

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbz0b09xBzXI7RU7bcbfky8k4tN4rp3GdMC3pJniA1s6HiME38IIDQ8mGcuC4nDemjJNBQ/exec');
      const data = await response.json();

      const match = data.find(item => String(item.drop_pincode) === pincode);

      if (!match) {
        result.textContent = 'Pincode not serviceable.';
        result.style.color = 'red';
      } else {
        const tatDays = parseInt(match.TAT, 10) || 0;
        const estimatedDate = new Date();
        estimatedDate.setDate(estimatedDate.getDate() + tatDays);

        const formattedDate = estimatedDate.toLocaleDateString(undefined, {
          weekday: 'long',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });

        const message = match['Message construct']?.replace('[date]', formattedDate) || '';
        result.innerHTML = message;
      }
    } catch (error) {
      console.error(error);
      result.textContent = 'Error checking pincode. Try again later.';
      result.style.color = 'red';
    }

    // Reset button
    button.disabled = false;
    button.textContent = 'CHECK';
  });
});

//   sticky add to cart offset effect
 
// document.addEventListener("DOMContentLoaded", function() {
//   const atcWrapper = document.getElementById('sticky-atc-wrapper');

//   if (!atcWrapper) return;

//   const originalOffset = atcWrapper.offsetTop;
//   const bottomOffset = originalOffset + atcWrapper.offsetHeight;

//   window.addEventListener('scroll', function() {
//     const scrollY = window.scrollY;
//     const viewportHeight = window.innerHeight;

//     const isAbove = scrollY + viewportHeight < originalOffset;
//     const isBelow = scrollY > bottomOffset;

//     if (isAbove || isBelow) {
//       atcWrapper.classList.add('sticky');
//     } else {
//       atcWrapper.classList.remove('sticky');
//     }
//   });

//   window.dispatchEvent(new Event('scroll'));
// });


// ✅ FINAL FIX: Sticky ATC using IntersectionObserver
// - No offsetTop math (unreliable across PDPs)
// - Works correctly at page top, middle, and bottom
// - Show sticky bar when ATC wrapper is OUT of viewport
// - Hide sticky bar when ATC wrapper is IN viewport

document.addEventListener("DOMContentLoaded", function () {
  const atcWrapper = document.getElementById('sticky-atc-wrapper');
  if (!atcWrapper) return;

  function initSticky() {
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText =
      'display:block;height:0;width:100%;pointer-events:none;visibility:hidden;';
    atcWrapper.parentNode.insertBefore(sentinel, atcWrapper);

    const spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.cssText =
      'display:block;height:0;width:100%;pointer-events:none;visibility:hidden;';
    atcWrapper.parentNode.insertBefore(spacer, atcWrapper.nextSibling);

    const GAP = 48;          // hysteresis dead-zone (px)
    let atcTop = 0, atcBottom = 0;
    let isSticky = false;
    let ticking = false;

    function measure() {
      // Document coords of the ORIGINAL ATC rectangle. Stable across sticky states.
      const top = sentinel.getBoundingClientRect().top + window.scrollY;
      atcTop = top;
      atcBottom = top + atcWrapper.offsetHeight;
    }

    function setSticky(on) {
      if (on === isSticky) return;
      isSticky = on;
      atcWrapper.classList.toggle('sticky', on);
      spacer.style.height = on ? atcWrapper.offsetHeight + 'px' : '0px';
    }

    function update() {
      const viewTop = window.scrollY;
      const viewBottom = viewTop + window.innerHeight;

      if (!isSticky) {
        // Turn ON when the ATC is clearly out of view — below OR above.
        const belowFold = viewBottom < atcTop - GAP;     // top of page: ATC not reached
        const scrolledPast = viewTop > atcBottom + GAP;   // ATC scrolled off the top
        if (belowFold || scrolledPast) setSticky(true);
      } else {
        // Turn OFF only once the ATC is comfortably back in view.
        const inView = viewBottom > atcTop + GAP && viewTop < atcBottom - GAP;
        if (inView) setSticky(false);
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    let rt;
    window.addEventListener('resize', () => {
      clearTimeout(rt);
      rt = setTimeout(() => { measure(); update(); }, 150);
    });

    measure();
    update();   // sets correct state on load, including at top of page
  }

  if (document.readyState === 'complete') initSticky();
  else window.addEventListener('load', initSticky);
});

// Sticky ATC Price Sync — untouched
document.addEventListener('DOMContentLoaded', function () {

  function updateStickyPrice() {

    const stickyPriceWrapper = document.querySelector('.sticky-price-wrapper');
    if (!stickyPriceWrapper) return;

    const priceContainer = document.querySelector('[id^="price-"]');
    if (!priceContainer) return;

    const saleBlock = priceContainer.querySelector('.price__sale');

    if (saleBlock) {

      const salePrice = saleBlock.querySelector('.price-item--sale')?.textContent.trim() || '';
      const comparePrice = saleBlock.querySelector('.price-item--regular')?.textContent.trim() || '';
      const discount = saleBlock.querySelector('.perc-off')?.textContent.trim() || '';

      stickyPriceWrapper.innerHTML = `
        <span class="sticky-sale-price">${salePrice}</span>
        ${comparePrice ? `<span class="sticky-mrp">MRP <s>${comparePrice}</s></span>` : ''}
        ${discount ? `<span class="sticky-discount">${discount}</span>` : ''}
      `;

    } else {

      const regularPrice =
        priceContainer.querySelector('.price-item--regular')?.textContent.trim() || '';

      stickyPriceWrapper.innerHTML = `
        <span class="sticky-sale-price">${regularPrice}</span>
      `;
    }
  }

  updateStickyPrice();

  const observer = new MutationObserver(() => {
    updateStickyPrice();
  });

  const priceContainer = document.querySelector('[id^="price-"]');
  if (priceContainer) {
    observer.observe(priceContainer, {
      childList: true,
      subtree: true
    });
  }
});

